import { Navigate } from "react-router-dom"
import Homepage from "../views/Homepage/Homepage"
import { Routes } from "../states/States"
import Login from "../components/UI/Login/Login"
import MobileOtpVerification from "../components/UI/OtpPage/MobileOtpVerification"
import CaptureImage from "../components/UI/CamptureImage/CamptureImage"
import VisitorForm from "../components/UI/VisitorForm/VisitorFormPage"
import VisitorFormPage from "../components/UI/VisitorForm/VisitorFormPage"

const RequireAuth = ({ children }: { children: JSX.Element }) => {
    const isAuthenticated = localStorage.getItem("token")
    if (!isAuthenticated) {
        return <Navigate to="/" replace />
    }
    return children
}

const CommonRoutes: Array<Routes> = [
    {
        path: "/",
        element: <Login />,
    },
    {
        path: "/home",
        element: (
            <>
                <RequireAuth>
                    <Homepage />
                </RequireAuth>
            </>
        ),
    },
    {
        path: "/verify-mobile",
        element: (
            <>
                <RequireAuth>
                    <MobileOtpVerification />
                </RequireAuth>
            </>
        ),
    },
    {
        path: "/capture-image",
        element: (
            <>
                <RequireAuth>
                    <CaptureImage />
                </RequireAuth>
            </>
        ),
    },
    {
        path: "/user-form",
        element: (
            <>
                <RequireAuth>
                    <VisitorFormPage/>
                </RequireAuth>
            </>
        ),
    },
]

export const Router: Array<Routes> = [
    ...CommonRoutes,
    /**
     *@description
     * Url to Embeded in Iframe
     *
     */
    // {
    //   path: "", // test route
    //   element: <Header />,
    //   children: [
    //     ...CommonRoutes,
    //     {
    //       path: "*", // test route
    //       element: <div>NOT FOUND</div>,
    //     },
    //   ],
    // },
]
